export default __webpack_public_path__ + "static/public-ready-0532c1eeadd8bc6b478f4e53af56ac5d.webp";